module.exports = __webpack_public_path__ + "img/loginBg.8f84abef.png";